import script from "./addClassToFacility.vue?vue&type=script&setup=true&lang=js"
export * from "./addClassToFacility.vue?vue&type=script&setup=true&lang=js"

import "./addClassToFacility.vue?vue&type=style&index=0&id=331a6d52&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-331a6d52"]])

export default __exports__